import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Client from "../../models/client";

const RECORS_PER_SEARCH = 20;

type ClientSelectProps = {
  value: Client | null;
  onChange: (_: Client | null) => void;
  disabled?: boolean;
  isClearable?: boolean;
};

const ClientSelect: React.FC<ClientSelectProps> = ({
  value,
  onChange,
  disabled,
  isClearable = false,
}) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (
      | Client
      | { options: Client[]; label?: string }
    )[]
  ): Promise<
    Response<Client, { options: Client[]; label?: string }, any>
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<Client>(
      "/clients/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: Client[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Seleccione un Cliente"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: Client) => `${option.name}`}
      getOptionValue={(option: Client) => `${option.id}`}
      value={value}
      isDisabled={disabled}
      isClearable={isClearable}
    />
  );
};

export default ClientSelect;
